export class Coords {
    constructor(latitude, longitude) {
        this.latitude = latitude;
        this.longitude = longitude;
    }
}
//# sourceMappingURL=Coords.js.map